export default __webpack_public_path__ + "static/media/medium.5588a8fd.svg";